import { LANGUAGE } from '../constants';
import type { Language } from '../types/common';
import type { OptionsType } from '../types/options';

/**
 * OptionsTypeから表示名を返す。
 * @param option [OptionsType]
 * @param language? [Language | undefined]
 * @returns [string]
 */
const getOptionsTypeLabel = (option: OptionsType, language: Language | undefined): string => {
  const label: string = language === LANGUAGE.JA ? option.nameJapanese : language === LANGUAGE.EN ? (option.nameEnglish ? option.nameEnglish : option.nameJapanese) : option.nameJapanese;
  return label;
};

export default getOptionsTypeLabel;
